export default __webpack_public_path__ + "1dbfcbd0f0c3abf596f2ad54dc6d9120.png";